import {
  CREATE_PINCODEAREA_FAILURE,
  CREATE_PINCODEAREA_REQUEST,
  GET_ALL_PINCODEAREA_REQUEST,
  GET_ALL_PINCODEAREA_SUCCESS,
  GET_ALL_PINCODEAREA_FAILURE,
  DELETE_PINCODEAREA_REQUEST,
  DELETE_PINCODEAREA_FAILURE,
  UPDATE_PINCODEAREA_REQUEST,
  UPDATE_PINCODEAREA_FAILURE,
  DELETE_PINCODEAREA_SUCCESS,
} from "./ActionType";

const initialState = {
  pinCodes: [],
  loading: false,
  error: "",
};

export const pinCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PINCODEAREA_REQUEST:
      return { ...state, loading: true };

    case CREATE_PINCODEAREA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_PINCODEAREA_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PINCODEAREA_SUCCESS:
      return { ...state, loading: false, error: "", pinCodes: action.payload };

    case GET_ALL_PINCODEAREA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PINCODEAREA_REQUEST:
      return { ...state, loading: true };

    case DELETE_PINCODEAREA_SUCCESS:
      return {
        ...state.pinCodes,
        loading: false,
        error: "",
        pincodes: state.pinCodes?.response?.filter(pnc => pnc.id !== action.payload)  // Remove deleted category
      };

    case DELETE_PINCODEAREA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PINCODEAREA_REQUEST:
      return { ...state, loading: true };

    case UPDATE_PINCODEAREA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
